import { Components, Theme } from '@mui/material/styles'
import { mobileLayoutStyles } from '../../utils/hooks/useIsMobileLayout'

export const dialogTheme: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    container: ({ theme }) => ({
      ...mobileLayoutStyles(theme, {
        alignItems: 'stretch',
      }),
    }),
    paper: ({ ownerState, theme }) => ({
      backgroundColor: theme.palette.background.paper,
      ...(!ownerState.fullScreen
        ? mobileLayoutStyles(theme, {
            borderRadius: 0,
            height: '100%',
            margin: 0,
            maxHeight: '100%',
            maxWidth: '100%',
            width: '100%',
          })
        : {}),
    }),
  },
}

export const dialogTitleTheme: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.header,
      '& button': {
        marginLeft: '2rem',
      },
      '& div > span > svg': {
        verticalAlign: 'text-bottom',
        fontSize: '4rem',
        marginRight: '2rem',
      },
    }),
  },
}

export const dialogContentTheme: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '28px 35px',
      backgroundColor: theme.palette.background.paper,
    }),
  },
}

export const dialogContentTextTheme: Components<Theme>['MuiDialogContentText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
    }),
  },
}
